export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelected: this.selected,
    };
  },
  computed: {
    buttonModifier() {
      return {
        'filter-button--selected': this.isSelected,
      };
    },
  },
  methods: {
    toggleFilter(e) {
      e.stopPropagation();
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        this.$emit('addFilter', this.id);
      } else {
        this.$emit('removeFilter', this.id);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/filter-button/filter-button.js